import { useDroppable } from "@dnd-kit/core"
import { useState } from "react"
import { Form } from "react-bootstrap";
import stringUtilities from "../../utilities/stringUtilities";
export const DroppableItem = ({ dndId, parent, handleChange }) => {
    const [value, setValue] = useState("");
    const { isOver, setNodeRef } = useDroppable({
        id: dndId,
        data: { dataShapeHeader: parent }
    })

    return <div ref={ setNodeRef } className={ `rounded border-dashed border-2 w-100 px-2 ${ isOver ? "border-success" : "border-secondary" }` } id="drop-container" >
        <Form.Group className='row justify-content-end'>
            <div className="d-flex align-items-center">
                <Form.Control onBlur={() => handleChange(value)} onChange={e => setValue(e.target.value)} className="border-0 px-0" size='sm' value={ value } type="text" />
                    { !stringUtilities.isNullOrEmpty(value) && <button onClick={() => handleChange(value)} className="btn p-0 text-primary"><i className="fi-check"></i></button> }
            </div>            
        </Form.Group>
    </div>
}